import styles from './Checkbox.module.css';
import * as React from 'react';
import classNames from 'classnames';

type CheckboxProps = {
  checked?: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
  children?: React.ReactNode;
};

const Checkbox = ({
  checked,
  onChange,
  className,
  children,
}: CheckboxProps) => {
  return (
    <label className={classNames(
      styles['checkbox'],
      'text-xxs uppercase tracking-wide cursor-pointer',
      className,
    )}>
      <input
        type="checkbox"
        checked={checked}
        onChange={({ target }) => onChange(target.checked)}
      />
      {children}
    </label>
  );
};

export default Checkbox;
